document.addEventListener('DOMContentLoaded', function() {
    const headerWrapper = document.querySelector('.custom-header-wrapper');
    const openBtn = document.getElementById('mobileMenuOpen');
    const closeBtn = document.getElementById('mobileMenuClose');
    const drawer = document.getElementById('mobileDrawer');
    const overlay = document.getElementById('drawerOverlay');

    function updateBodyPadding() {
      if (headerWrapper) {
        document.body.style.paddingTop = headerWrapper.offsetHeight + 'px';
      }
    }
    
    updateBodyPadding();
    window.addEventListener('resize', updateBodyPadding);

    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        headerWrapper.classList.add('is-scrolled');
      } else {
        headerWrapper.classList.remove('is-scrolled');
      }
    });

    function openMenu() {
      drawer.classList.add('active');
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      drawer.classList.remove('active');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);
  });

document.addEventListener('DOMContentLoaded', function() {
  
  function updateBadges() {
    const soldOutBadges = document.querySelectorAll('.color-custom-badge-sold-out');
    
    soldOutBadges.forEach(function(badge) {
      badge.classList.remove('color-custom-badge-sold-out');
      badge.classList.add('color-scheme-3');
      badge.textContent = 'Coming Soon';
    });
  }

  // Run initial check
  updateBadges();

  // Watch for dynamic page updates (variant switches, AJAX drawer carts, collection filters)
  const observer = new MutationObserver(function() {
    updateBadges();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});
// --- AJAX Dynamic Cart Auto-Updater (Global Version) ---
function refreshCustomCartBubble() {
  fetch(`${window.Shopify.routes.root}cart.js`)
    .then(response => response.json())
    .then(cart => {
      const cartCount = cart.item_count;

      // Select target header elements
      const bubble = document.querySelector('[ref="cartBubble"], .cart-bubble');
      const countElement = document.querySelector('[ref="cartBubbleCount"], .cart-bubble__text-count');
      const srElement = document.querySelector('.cart-bubble__text .visually-hidden');

      if (cartCount > 0) {
        if (bubble) bubble.classList.remove('visually-hidden');
        if (countElement) {
          countElement.classList.remove('hidden');
          countElement.textContent = cartCount;
        }
        if (srElement) {
          srElement.textContent = `Total items in shopping bag: ${cartCount}`;
        }
      } else {
        if (bubble) bubble.classList.add('visually-hidden');
        if (countElement) {
          countElement.classList.add('hidden');
          countElement.textContent = '0';
        }
      }
    })
    .catch(error => console.error('Error updating custom cart bubble:', error));
}

// 1. Intercept native form submissions (Handles standard add/update forms)
document.addEventListener('submit', function(event) {
  const form = event.target;
  if (form.action && (form.action.includes('/cart/add') || form.action.includes('/cart/change') || form.action.includes('/cart/update') || form.action.includes('/cart'))) {
    setTimeout(refreshCustomCartBubble, 600);
  }
});

// 2. Intercept modern background Fetch / XHR network pipelines
const nativeFetch = window.fetch;
window.fetch = function(...args) {
  return nativeFetch.apply(this, args).then(response => {
    if (args[0] && typeof args[0] === 'string') {
      const url = args[0];
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
        setTimeout(refreshCustomCartBubble, 600);
      }
    }
    return response;
  });
};

// 3. Listen directly to dynamic click changes (Catching quantities/trash buttons on the cart page)
document.addEventListener('click', function(event) {
  const target = event.target;
  
  // Check if click was on a plus/minus button or a delete icon/button
  const isQuantityTrigger = target.closest('.quantity__button') || 
                            target.closest('[name="plus"]') || 
                            target.closest('[name="minus"]') || 
                            target.closest('.cart-item__remove-button') || 
                            target.closest('a[href*="/cart/change"]');

  if (isQuantityTrigger) {
    // Wait slightly for the cart page logic to finish processing the state adjustment, then sync header
    setTimeout(refreshCustomCartBubble, 800);
  }
});

// 4. Capture dynamic keyboard inputs (If someone manually keys in a quantity number and clicks away)
document.addEventListener('change', function(event) {
  if (event.target && event.target.classList.contains('quantity__input')) {
    setTimeout(refreshCustomCartBubble, 800);
  }
});